export const ROUTE_MAIN = "/";

// Static public pages (no auth required)
export const ROUTE_PRIVACY_POLICY = "/privacy-policy";
export const ROUTE_TERMS_AND_CONDITIONS = "/terms-and-conditions";

// Auth Routes

export const ROUTE_WHAT_YOUR_NAME = "/what-your-name";

// Profile

export const ROUTE_MOBILE_SETTINGS = "/mobile-settings";

// Jobs

export const ROUTE_GREATE_JOB = "/great-job";

export const ROUTE_JOB_CONGRATS = "/jobs-congrats";

// New Changes

export const ROUTE_VERIFY_MOBILE = "/verify-mobile";
export const ROUTE_WELCOME = "/welcome";
export const ROUTE_UPLOAD_PIC = "/upload-pic";
export const ROUTE_LOOKING_FOR = "/looking-for";
export const ROUTE_GREAT_START = "/great-start";
export const ROUTE_SIGNIN_NEW = "/signin-new";
export const ROUTE_WELCOME_NEW = "/welcome-new";
export const ROUTE_FANTASTIC = "/fantastic";
export const ROUTE_BROWSE_JOBS_NEW = "/browse-job-new";
export const ROUTE_JOB_DETAILS = "/job-details";
export const ROUTE_PUBLIC_JOB_DETAILS = "/public-job-details";
export const ROUTE_PROFILE_CONSIST = "/profile-consist";
export const ROUTE_EDUCATION_NEW = "/education-new";
export const ROUTE_EXPERIENCE_NEW = "/experience-new";
// export const ROUTE_EXPERIENCE_NEW_DETAILS = "/experience-new-details";
export const ROUTE_SKILLSET_NEW = "/skillset-new";
export const ROUTE_OTHER_TOOLS = "/other-tools";
export const ROUTE_CERTIFICATION_NEW = "/certification-new";
// export const ROUTE_CERTIFICATION_NEW_DETAILS = "/certification-new-details";
export const ROUTE_CRAFTING_VIDEO = "/crafting-video";
export const ROUTE_GREATE_JOB_PROFILE = "/great-job-profile";
export const ROUTE_COMPLETE_PROFILE = "/complete-profile";
export const ROUTE_NOTIFICATIONS = "/notifications";

// User
export const ROUTE_PROMPT = "/prompt";
export const ROUTE_UPLOAD_FINAL_VIDEO = "/upload-final-video";
export const ROUTE_PROFILER = "/profiler";
export const ROUTE_QUESTION = "/question";
export const ROUTE_CONNECTOR = "/connector";
export const ROUTE_PERSONALITY_PROFILER = "/personality-profiler";
export const ROUTE_RECORDING_TIPS = "/recording-tips";
export const ROUTE_SECTION_COMPLETE = "/section-complete";
export const ROUTE_SECTION_FINAL = "/section-final";
export const ROUTE_WELL_DONE = "/welldone";
export const ROUTE_GREAT_GOING = "/great-going";
export const ROUTE_TAKE_TEST = "/take-test";
export const ROUTE_VIDEO_START = "/video-start";
export const ROUTE_VIDEO_COMPLETE = "/video-complete";

// B2B

export const ROUTE_CLIENT_LOGIN = "/login-client";
export const ROUTE_REGISTER_COMPLETE = "/register-complete";
export const ROUTE_JOBS_DASHBOARD = "/jobs-dashboard";  
export const ROUTE_CLIENT_JOB_DETAILS = "/client-job-details";
export const ROUTE_VIDEO_DETAILS = "/video-details";
export const ROUTE_CREATE_JOB = "/create-job";
export const ROUTE_VIEW_JOB = "/view-job";
export const ROUTE_PROFILE_SETTINGS = "/profile-settings";
export const ROUTE_COMPANY_DETAILS = "/company-details";
export const ROUTE_COMPANY_NEW = "/company-new";
export const ROUTE_COMPANY_EDIT = "/company-edit/:id";
export const ROUTE_COMPANY_LIST = "/company-list";
export const ROUTE_USER_LIST = "/user-list";

export const ROUTE_COMPANY_JOBS_DASHBOARD = "/company-jobs-dashboard"; 
export const ROUTE_COMPANY_CREATE_JOB = "/company/create-job/:companyId";
export const ROUTE_COMPANY_JOB_DETAILS = "/company-job-details";
export const ROUTE_REPORTS = "/reports";
export const ROUTE_SHARE_PROFILE = "/shareprofile/:jobId/:profileid";
/** Candidate profile URL: /candidate-profile/:profileName/:profileId (e.g. /candidate-profile/john-doe/123) */
export const ROUTE_CANDIDATE_PROFILE = "/candidate-profile/:profileName/:profileId";

/** Build a URL-safe slug from a display name (e.g. "John Doe" -> "john-doe") */
export function slugifyProfileName(name: string | undefined | null): string {
  if (!name || typeof name !== "string") return "profile";
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

const PREVIEW_CACHE_SUFFIX_CHARS = "abcdefghijklmnopqrstuvwxyz";

/** Random lowercase suffix for WhatsApp / OG preview cache busting (must match backend PreviewSlugUtils). */
export function randomPreviewCacheSuffix(length = 4): string {
  return Array.from({ length }, () =>
    PREVIEW_CACHE_SUFFIX_CHARS[Math.floor(Math.random() * PREVIEW_CACHE_SUFFIX_CHARS.length)]
  ).join("");
}

export type CandidateProfilePathOptions = {
  /** Append a random 4-letter suffix when building share/preview links */
  cacheBust?: boolean;
};

/** Build preview path: preview/:profileName/:profileId (optional cache-buster suffix for share links) */
export function buildCandidateProfilePath(
  profileId: number | string,
  profileName?: string | null,
  options?: CandidateProfilePathOptions
): string {
  const slug = slugifyProfileName(profileName ?? "");
  const id = String(profileId);
  const slugSegment = options?.cacheBust ? `${slug}-${randomPreviewCacheSuffix()}` : slug;
  return `preview/${slugSegment}/${id}`;
}